module.exports = __webpack_public_path__ + "static/matbuu-sm-daf873be8ba8130bd95ee42b04419808.jpg";